import { render, staticRenderFns } from "./BinanceBlogSupervisor.vue?vue&type=template&id=70371777&scoped=true&"
import script from "./BinanceBlogSupervisor.vue?vue&type=script&lang=js&"
export * from "./BinanceBlogSupervisor.vue?vue&type=script&lang=js&"
import style0 from "./BinanceBlogSupervisor.vue?vue&type=style&index=0&id=70371777&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70371777",
  null
  
)

export default component.exports